<template>
    <div class="search">
        <Row :gutter="4">
            <!-- 选择公司 -->
            <div v-if="company==1">
                <Col span="4">
                    <Select v-model="companyId" filterable :placeholder="$t('alarms.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                        <Option value=" " selected>{{$t('alarms.common.all')}}</Option>
                        <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </div>
            <Col span="4">
                <Input search v-model="alertRuleSearchKey" :placeholder="$t('alarms.common.filterByAlertRuleName')" @on-search="searchAlertRule()"/>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import TableWebsiteHealthStatusWarning from './TableWebsiteHealthStatusWarning'
    var tableWebsiteHealthStatusWarning = TableWebsiteHealthStatusWarning;
    export default {
        name: 'WebsiteHealthStatusWarningSearch',
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                alertRuleSearchKey:''
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
                this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                    this.companyList = res.data;
                });
            },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableWebsiteHealthStatusWarning.methods.showAll();
            },
            // 按规则名称搜索
            searchAlertRule: function(){
                eventBus.$emit('alertRuleSearchName', this.alertRuleSearchKey);
                tableWebsiteHealthStatusWarning.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .search
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/non_cloud_resources/website_health_status/WebsiteHealthStatusWarningSearch.vue